var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.85 1.82a2.82 2.82 0 0 1 3.98 0l.34.35a2.82 2.82 0 0 1 0 3.99l-2.01 2.02a2.82 2.82 0 0 1-3.99 0l-.34-.35a2.82 2.82 0 0 1 0-3.99l2.02-2.02ZM3.85 9.82a2.82 2.82 0 0 1 3.98 0l.34.35a2.82 2.82 0 0 1 0 3.98l-2.01 2.03a2.82 2.82 0 0 1-3.99 0l-.34-.35a2.82 2.82 0 0 1 0-3.99l2.02-2.02ZM6.2 11.8l5.6-5.6",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgLink;